import icons from '@shared/ui/icons';
import { Button } from '@shared/ui/Button/Button';
import React, { FC, ReactNode } from 'react';

type NoLabelsProps = {
  children?: ReactNode;
  action?: () => void;
  actionText?: string;
  iconName: keyof typeof icons;
  title: string | JSX.Element;
};

export const NoContent: FC<NoLabelsProps> = ({ children, action, iconName, actionText, title }) => {
  const Icon = icons[iconName];
  const handleClick = () => {
    if (action instanceof Function) {
      action();
    }
  };

  return (
    <div className="relative my-3 flex grow items-center justify-center">
      <div className="flex max-w-[50rem] flex-col items-center justify-center gap-2">
        <Icon
          width={60}
          height={60}
          className="text-pastelBlue"
        />
        <h4 className="text-1624 text-center">{title}</h4>
        <footer className="flex justify-center gap-2">
          {children || (
            <Button
              className="!bg-blackOlive !text-1420 hover:!bg-dodgerBlue border-none !px-3 text-white"
              onClick={handleClick}
            >
              {actionText}
            </Button>
          )}
        </footer>
      </div>
    </div>
  );
};
